export default async function(context) {
  if (context.route.path === "/signup") {
    context.redirect("/signup-new");
  }
}
